import React from "react";
import PropTypes from "prop-types";
import CalciteChip from "../../shared/CalciteChip";
import CalciteRadioButton from "../../shared/CalciteRadioButton";
import CalciteLabel from "../../shared/CalciteLabel";

/**
 * A component that represents a customer number card.
 * @param {Object} props - The props.
 * @param {Object} props.customerNumber - The customer number.
 * @param {Function} props.onSelectedCustomerNumber - The function to call when a customer number is selected.
 * @param {Object} props.localizedKeys - The localized keys.
 * @returns {JSX.Element} The component.
 */
const CustomerNumberCard = ({ customerNumber, onSelectedCustomerNumber, localizedKeys }) => {
  const isIndividual =
    customerNumber.IndustryKey === "Z" || customerNumber.IndustryKey === "E6" || customerNumber.isIndividual;

  return (
    <div
      className={`customer-number-card ${customerNumber.selected ? "customer-number-card--selected" : ""}`}
      onClick={() => onSelectedCustomerNumber(customerNumber)}
    >
      <div className="customer-number-card__header padding-bottom--2">
        <div className="customer-number-card__type padding-bottom--1">
          <CalciteChip
            scale="s"
            kind="neutral"
            style={isIndividual ? null : { "--calcite-ui-foreground-2": "rgb(223, 239, 250)" }}
          >
            {isIndividual ? localizedKeys.personalCustomerTypeLabel : localizedKeys.orgCustomerTypeLabel}
          </CalciteChip>
        </div>
        <div className="customer-number-card__radio">
          <CalciteLabel>
            <span className="assistText">
              {customerNumber.OrganizationName} {localizedKeys.globalCustomerNumberLabel}
              {isNaN(customerNumber.CustomerNumber) ? localizedKeys.newLabel : customerNumber.CustomerNumber}
            </span>
            <CalciteRadioButton checked={customerNumber.selected} />
          </CalciteLabel>
        </div>
        {customerNumber.OrganizationName && (
          <div className="customer-number-card__title">
            {customerNumber.OrganizationName}
            {isNaN(customerNumber.CustomerNumber) && localizedKeys.newLabel && (
              <span className="padding-left--1">
                <CalciteChip scale="s" appearance="outline-fill" kind="inverse">
                  {localizedKeys.newLabel}
                </CalciteChip>
              </span>
            )}
          </div>
        )}
        {(!isNaN(customerNumber.CustomerNumber) || customerNumber.Department) && (
          <div className="customer-number-card__subtitle">
            {!isNaN(customerNumber.CustomerNumber) && (
              <span>
                {localizedKeys.globalCustomerNumberLabel}
                {customerNumber.CustomerNumber}
              </span>
            )}
            {customerNumber.Department && <span> - {customerNumber.Department} </span>}
          </div>
        )}
      </div>
      <div className="customer-number-card__body">
        <div className="customer-number-card__text">
          {customerNumber.Address1 && <span>{customerNumber.Address1}</span>}
          {customerNumber.City && (
            <span>
              <br />
              {customerNumber.City}
            </span>
          )}
          {customerNumber.State && <span>, {customerNumber.State}</span>}
          {customerNumber.Zipcode && (
            <span>
              <br />
              {customerNumber.Zipcode}
            </span>
          )}
          <span> {customerNumber.Country} </span>
        </div>
      </div>
    </div>
  );
};

CustomerNumberCard.propTypes = {
  customerNumber: PropTypes.object,
  onSelectedCustomerNumber: PropTypes.func,
  localizedKeys: PropTypes.object,
};

export default CustomerNumberCard;
